import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
  import Choice from '@/components/common/Choice.vue'
  import useIcons from '@/composables/useIcons'
  import KetchUpButton from '@/components/common/KetchUpButton.vue'
  import LoadingSpinner from '@/components/common/LoadingSpinner.vue'
  import type { PropType } from 'vue'
  import type { LeuckentextChoice } from '@/services/interfaces/Course'
  import type { SvgRendererProps } from '@/services/interfaces/Common'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'LeuckentextAnswersPaneMobile',
  props: {
    choices: {
      type: Array as PropType<LeuckentextChoice[]>,
      required: true,
    },
    disablePreviousButton: {
      type: Boolean,
      default: true,
    },
    showSubmitText: {
      type: Boolean,
      default: false,
    },
    loadingResults: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['on-choice-click', 'previous', 'next-or-submit'],
  setup(__props) {

  
  

  const { uncheckedCircle, checkedCircle } = useIcons()

  const selectedChoice = computed(() => {
    return (selectable: boolean): SvgRendererProps => {
      return selectable
        ? { icon: uncheckedCircle.value, strokeColor: 'var(--primary-text-color)' }
        : { icon: checkedCircle.value, strokeColor: 'var(--primary-text-color)' }
    }
  })

return { __sfc: true,uncheckedCircle, checkedCircle, selectedChoice, computed, Choice, useIcons, KetchUpButton, LoadingSpinner }
}

})